import { IComponentOptions } from 'angular';
import {
    DjangoLicenseType,
    IDjangoApi1License,
} from '../../tn.common/classes/Model/Licenses';
import { LicenseService } from '../license.service/license-service';
import licenseTableRowsTemplate from './license-table-rows.html';


export class LicenseTableRowsController {
    colllection: IDjangoApi1License[] = [];
    detailed = false;
    type?: DjangoLicenseType;
    onShowUpgradeRenewPopover?: (args: {
        $event: Event;
        licenses: IDjangoApi1License[];
        licenseType: DjangoLicenseType;
    }) => void;
    onShowSubsetPopover?: (args: {
        $event: Event;
        licenses: IDjangoApi1License[];
        licenseType: DjangoLicenseType;
    }) => void;

    static $inject = ['tnLicenseService'];
    constructor(protected licenseService: LicenseService) {}

    canUpgrade(l: IDjangoApi1License, t: DjangoLicenseType): boolean {
        return this.licenseService.canUpgrade(l, t);
    }

    showUpgradeRenewPopover(
        $event: Event,
        licenses: IDjangoApi1License[],
        licenseType: DjangoLicenseType
    ): void {
        this.onShowUpgradeRenewPopover &&
            this.onShowUpgradeRenewPopover({ $event, licenses, licenseType });
    }

    showSubsetPopover(
        $event: Event,
        licenses: IDjangoApi1License[],
        licenseType: DjangoLicenseType = 'web'
    ): void {
        this.onShowSubsetPopover &&
            this.onShowSubsetPopover({ $event, licenses, licenseType });
    }
}

export const LicenseTableRowsComponent: IComponentOptions = {
    bindings: {
        collection: '=',
        type: '=',
        detailed: '=?',
        onShowUpgradeRenewPopover: '&?',
        onShowSubsetPopover: '&?',
    },
    template: licenseTableRowsTemplate,
    controller: LicenseTableRowsController,
};
